import React, { useCallback } from 'react';
import { Table, Typography } from 'antd';

import { useSalesRegion } from '@hooks/SalesRegionContext';
import TableFilters from '@components/TableFilters';
import { SearchOutlined } from '@ant-design/icons';
import '../../styles.css';
const { Text } = Typography;

interface StatesTableProps {
  showModal: Function;
  representativeCode: number;
}
const StatesTable: React.FC<StatesTableProps> = ({ showModal, representativeCode }) => {
  const { operationalArea, loadSalesRegionsCustomers } = useSalesRegion();

  const handleCustomersModal = useCallback(
    (stateAbbreviation: string) => {
      loadSalesRegionsCustomers(representativeCode, { stateAbbreviation });
      showModal();
    },
    [showModal, loadSalesRegionsCustomers, representativeCode],
  );

  const columnsStates = [
    {
      title: 'Estado',
      dataIndex: 'stateName',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <TableFilters
          inputPlaceholder={'Filtrar pelo Estado'}
          inputValue={selectedKeys[0]}
          onChangeInputValue={setSelectedKeys}
          onFilter={confirm}
          onClearFilters={clearFilters}
        />
      ),
      filterIcon: () => <SearchOutlined />,
      onFilter: (value: any, record: any) => {
        return record.stateName ? record.stateName.toString().toLowerCase().includes(value.toLowerCase()) : '';
      },
    },
    {
      render: (record: any) => (
        <Text
          style={{ color: 'var(--primary-color)', fontWeight: 'bold', cursor: 'pointer' }}
          onClick={() => handleCustomersModal(record.stateCode)}
        >
          Ver clientes
        </Text>
      ),
      align: 'right' as 'right',
    },
  ];

  return (
    <>
      {operationalArea.operationalAreaStates?.length > 0 && (
        <Table
          className="mt-8 custom-table"
          columns={columnsStates}
          dataSource={operationalArea.operationalAreaStates}
          pagination={{ showSizeChanger: false, style: { marginTop: '24px' }, hideOnSinglePage: false }}
          scroll={{ x: 800 }}
        />
      )}
    </>
  );
};

export default StatesTable;
